import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSelector } from 'react-redux';
import { validationSchema } from '../validationSchema';
import { TRelatedCompanies } from '../types';
import { getInitialValues } from '../utils';
import { useMemo } from 'react';
import { selectRelatedCompanies } from '~/store/identification-form/selectors';

export const useRelatedCompaniesForm = () => {
  const formData = useSelector(selectRelatedCompanies);
  const initialValues = useMemo(() => getInitialValues(formData), []);

  const form = useForm<TRelatedCompanies>({
    resolver: yupResolver(validationSchema) as unknown as Resolver<TRelatedCompanies>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: initialValues,
  });

  return form;
};
